export const MOBILE_BREAKPOINT = 540;
export const MOBILE_PAGE_SIZE = 12;
export const DESKTOP_PAGE_SIZE = 24;

export function getResponsivePageSize(width = (typeof window !== 'undefined' ? window.innerWidth : null)) {
  if (typeof width !== 'number') return DESKTOP_PAGE_SIZE;
  return width <= MOBILE_BREAKPOINT ? MOBILE_PAGE_SIZE : DESKTOP_PAGE_SIZE;
}
